import { Box } from '@src/components';
import type { ReactNode } from 'react';

interface TwoColumnProps {
  primary?: ReactNode;
  secondary?: ReactNode;
}

export default function TwoColumn({ primary, secondary }: TwoColumnProps) {
  return (
    <>
      <Box>{primary}</Box>
      {secondary && <Box>{secondary}</Box>}
    </>
  );
}
